import React, { useState } from 'react';
import '../css/CreateTicket.css';

const CreateTicket = () => {
  const [form, setForm] = useState({
    email: '',
    subject: '',
    type: 'Support',
    description: ''
  });

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Ticket submitted:', form);
  };

  return (
    <div className="container">
      <div className="form-wrapper">
        <h1 className="title">Create a Support Ticket</h1>
        <form onSubmit={handleSubmit} className="form">
          <div className="form-group">
            <label className="label">Email</label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              required
              className="input"
            />
          </div>
          
          <div className="form-group">
            <label className="label">Subject</label>
            <input
              type="text"
              name="subject"
              value={form.subject}
              onChange={handleChange}
              required
              className="input"
            />
          </div>
          
          <div className="form-group">
            <label className="label">Type</label>
            <select
              name="type"
              value={form.type}
              onChange={handleChange}
              className="select"
            >
              <option>Support</option>
              <option>Billing</option>
              <option>Bug Report</option>
              <option>Feature Request</option>
            </select>
          </div>
          
          <div className="form-group">
            <label className="label">Description</label>
            <textarea
              name="description"
              value={form.description}
              onChange={handleChange}
              rows="4"
              required
              className="textarea"
            />
          </div>
          
          <button type="submit" className="submit-btn">
            Submit Ticket
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreateTicket;